import { Component, OnInit, ViewChild, AfterViewInit } from "@angular/core";
import { Http } from '@angular/http';
import { Router } from '@angular/router';

import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { GlowAuthService } from '../../services/glowadminservices/glowauth.service';
import { ApplicationSelectorService } from "../../services/app-selector.service";

@Component({
    styleUrls: ['./login.component.scss', '../public-components.scss'],
    templateUrl: './login.component.html',
})

export class LoginComponent {
    public loginDetails : FormGroup; 
    public errorString: string = "Login Error";
    public formError: boolean = false;
    public loading: boolean;
  
    passwordType: string = 'password';
    passwordIcon: string = 'Show Password';

    constructor(
        private appSelectorService: ApplicationSelectorService,
        private authService: GlowAuthService,
        private formBuilder: FormBuilder,
        private router: Router) {
    
        this.loginDetails = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

    }
    
    // Attempt to login in through our User service
    doLogin() {
        this.loading = true;
        this.formError = false;
        
        console.log("Login attempt")
        this.authService.login(this.loginDetails.value).subscribe((authResponse) => {
            // this.loading = false;

            if(authResponse === true){
                this.appSelectorService.selectDefaultApplication();
                this.router.navigateByUrl('pages/home')
            } else {
                this.formError = true;
                this.errorString = "Access Denied"
            }

        }, (err) => {
            this.loading = false;
            console.log("Error during login: ", err)
            this.formError = true;
            this.errorString = "Invalid user name or password"
        
        });
    }

    hideShowPassword() {
        this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
        this.passwordIcon = this.passwordIcon === 'Hide Password' ? 'Show Password' : 'Hide Password';
    }


}